"use client";
import Box from "@mui/material/Box";
import * as React from "react";
import Footer from "@AdbhutByte/utils/components/Footer";
import Header from "@AdbhutByte/utils/components/Header";
import Main from "@AdbhutByte/utils/components/Main";
// import FollowLoading from "@AdbhutByte/app/[follow]/loading";
// import FollowLoading from "@AdbhutByte/app/(follow)/social/loading";
// import PolicyLoading from "@AdbhutByte/app/policies/[policy]/loading";
// import HomeLoading from "@AdbhutByte/app/loading";

interface CSLayoutProps {
  children?: React.ReactNode | Array<React.ReactNode>;
}

function Layout({ children }: CSLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header />
      <React.Suspense>
        <Main>{children}</Main>
      </React.Suspense>
      <Footer />
    </Box>
  );
}

export default Layout;
